import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/endOfMonth/index.js';

var require$$47 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$47 as default };
